<script setup lang="ts">
import type { EmptyCallback } from '../../utils/global-types';

defineProps<{
    options: any,
    source: string,
    close: EmptyCallback,
}>();
</script>
<template>
    <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" @click="close">
            <i class="fas fa-times"></i>
        </button>
        &nbsp;
    </div>
    <div class="modal-body">
        <iframe :src="source" :style="options?.style || ''"></iframe>
    </div>
</template>